var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCardShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.25 11.5V6.25C24.25 5.85218 24.092 5.47064 23.8107 5.18934C23.5294 4.90804 23.1478 4.75 22.75 4.75H6.25C5.85218 4.75 5.47064 4.90804 5.18934 5.18934C4.90804 5.47064 4.75 5.85218 4.75 6.25V18.25C4.75 18.6478 4.90804 19.0294 5.18934 19.3107C5.47064 19.592 5.85218 19.75 6.25 19.75H12.25",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 9.25H24.25",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 13H13.75",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 16H10.75",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.25 19.75C27.2534 21.4965 26.6605 23.1918 25.5695 24.5556C24.4785 25.9194 22.9546 26.8699 21.25 27.25C19.5454 26.8699 18.0215 25.9194 16.9305 24.5556C15.8395 23.1918 15.2466 21.4965 15.25 19.75V16.209C15.2499 15.9142 15.3366 15.6259 15.4993 15.3801C15.662 15.1343 15.8936 14.9419 16.165 14.827C17.7662 14.1169 19.4984 13.75 21.25 13.75C23.0016 13.75 24.7338 14.1169 26.335 14.827C26.6064 14.9419 26.838 15.1343 27.0007 15.3801C27.1635 15.6259 27.2502 15.9142 27.25 16.209V19.75Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 16.75V22.75",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 19.75H24.25",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardShield);
export default __webpack_public_path__ + "static/media/creditCardShield.7bab4391.svg";
export { ForwardRef as ReactComponent };